import classNames from "classnames";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { memo } from "react";

import { useCalendarContext } from "../../context/calendar_context";
import css from "./days.module.scss";

export const DayDividers = memo(() => {
  const { days } = useCalendarContext();
  const { formatDate } = useDateFormatter();

  return (
    <div className={css.dayDividersRoot}>
      {days.map(({ date, left, width }) => {
        const formattedDate = formatDate(date);
        return (
          <div
            key={formattedDate}
            className={classNames(css.day, css.dayDivider)}
            title={formattedDate}
            style={{ width, left }}
          />
        );
      })}
    </div>
  );
});

DayDividers.displayName = "DayDividers";
